import React, { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import useSocket from "../../../hooks/useSocket";
import GalaxyLayout from "../../client/components/layout/GalaxyLayout";
import "../../../assets/galaxy/RangBaz.css";
import axiosInstance from "../../../utils/axiosInstance";
import { setUserData } from "../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";

export default function AndarBaharGalaxy() {
  const [array_list, set_array_list] = useState([]);
  const [betList, setBetList] = useState([]);

  const [chipActive, setChipActive] = useState(100);

  const [andarAmount, setAndarAmount] = useState(0);
  const [baharAmount, setBaharAmount] = useState(0);

  let andarCardString = [];
  const [andarCardArray, setAndarCardArray] = useState("");
  const [gameRoundId, setGameRoundId] = useState("");

  const [loopFinalAndarCardArray, setLoopFinalAndarCardArray] = useState([]);
  const [loopFinalBaharCardArray, setLoopFinalBaharCardArray] = useState([]);

  const [andarWin, setAndarWin] = useState(false);
  const [baharWin, setBaharWin] = useState(false);

  const [resultList, setResultList] = useState([]);

  let finalAndarCardArray = [];
  let finalBaharCardArray = [];
  const dispatch = useDispatch();

  //const [baharAmount, setBaharAmount] = useState(0);

  let eventStatus = "";

  const { data, isConnected } = useSocket({
    marketId: null,
    mtype: "galaxy",
    type: "andar_bahar"
  });
  console.log("Socket data:", data?.data);
  //console.log("Socket result:", data?.data?.result);

  const payloadResult = data?.data?.result;

  let andarOdd = 0;
  let baharOdd = 0;
  let galaxyOdds = null;
  let jokerCard = 1;
  let roundId = "";
  let isCallSend = false;
  let timeLeft = "";

  let left_time = 0;
  let cardsDesc = "";
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const placeBet = async () => {
    let totalAmount = 0;
    if (array_list != "" && array_list.length > 0) {
      for (let j = 0; j < array_list.length; j++) {
        let obj = array_list[j];
        totalAmount = totalAmount + obj.amount;
      }
    }
    //console.log("totalAmount->", totalAmount);
    //console.log("placeBet->", array_list);
    //console.log("roundId->", roundId);

    try {
      let betObj = {};
      betObj.game_name = "andarbahar_galaxy";
      betObj.catmid = roundId;
      betObj.betPlaceArr = array_list;
      betObj.game_type = 10;

      set_array_list([]);

      const response = await axiosInstance.post(
        "/casino/place-bet-casino-multiple",
        betObj
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data?.status !== undefined &&
        response.data?.status !== null
      ) {
        getBetList();
        fetchUserData();
      }
    } catch (error) {
      if (error.response?.data !== undefined && error.response?.data !== null) {
        debugger;
      }
    }
  };

  const updateUserData = async (userData) => {
    await dispatch(setUserData(userData));
  };

  if (data != null && data.data.data !== null && data.data.data !== undefined) {
    updateUserData(data?.user);
    galaxyOdds = data.data.data;
    andarOdd = galaxyOdds.b1;
    baharOdd = galaxyOdds.b2;
    jokerCard = galaxyOdds.j1;
    roundId = galaxyOdds.cat_mid;

    left_time = galaxyOdds.left_time;
    timeLeft = galaxyOdds.left_time;
    eventStatus = galaxyOdds.evt_status;
    cardsDesc = galaxyOdds.cards_desc;

    if (array_list.length > 0 && timeLeft < 8 && !isCallSend) {
      //console.log("timeLeft->", timeLeft);
      //console.log("roundId->", roundId);
      placeBet();
      isCallSend = true;
    }
    //console.log("galaxyOdds:", galaxyOdds);
    //createCardString(cardsDesc);
  }

  const getBetList = async () => {
    if (roundId !== "") {
      try {
        let betObj = {};
        betObj.catmid = roundId;
        betObj.game_name = "andarbahar_galaxy";
        const response = await axiosInstance.post(
          "/casino/get-casino-bet-list",
          betObj
        );

        setBetList(response.data);
        console.log("betList->", response.data);
      } catch (error) {}
    }
  };

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  useEffect(() => {
    clearWinner();
    if (cardsDesc != "") {
      setAndarCardArray(cardsDesc);
    }
  }, [cardsDesc]);

  let cardIndex = 0;
  let intervalHolder;
  const test = () => {
    if (andarCardArray !== "") {
      let andarCardArrayNew = andarCardArray.split(",");
      console.log("cardIndex->", cardIndex);
      let cardName = "";
      if (cardIndex % 2 == 0) {
        cardName = andarCardArrayNew[cardIndex];
        finalAndarCardArray.push(cardName);
      } else {
        cardName = andarCardArrayNew[cardIndex];
        finalBaharCardArray.push(cardName);
      }

      cardIndex++;

      setLoopFinalAndarCardArray(finalAndarCardArray);
      setLoopFinalBaharCardArray(finalBaharCardArray);

      if (cardIndex >= andarCardArrayNew.length) {
        //console.log("clearInterval->", intervalHolder);
        clearInterval(intervalHolder);
        clearWinner();

        const result = data?.data?.data?.result;

        if (result == 1) {
          setBaharWin(true);
        } else if (result == 2) {
          setAndarWin(true);
        }
      }
    }
  };

  const fetchUserData = async () => {
    //console.log("Fetching events...");
    try {
      const response = await axiosInstance.get("/user");
      //console.log("user-response->",response);
      if (response.data !== "") {
        await dispatch(setUserData(response.data));
      }
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  useEffect(() => {
    if (andarCardArray != "") {
      //console.log("useEffect is call->", andarCardArray);
      intervalHolder = setInterval(test, 1000);
    }
  }, [andarCardArray]);

  const undo = () => {
    if (array_list !== null && array_list.length > 0) {
      let firstElement = array_list[0];
      let teamname = firstElement.teamname;

      if (teamname == "Bahar") {
        setBaharAmount(0);
      } else if (teamname == "Andar") {
        setAndarAmount(0);
      }
      let newArr = array_list.slice(1);
      set_array_list(newArr);
    }
  };

  const initializeBet = (betType, teamname, type, price) => {
    if (left_time > 5) {
      let amt = 0;

      if (teamname == "Bahar") {
        amt = baharAmount + chipActive;
        setBaharAmount(amt);
      } else if (teamname == "Andar") {
        amt = andarAmount + chipActive;
        setAndarAmount(amt);
      }

      let indexFound = -1;

      //console.log("amt->", amt);
      //console.log("before_array_list->", array_list);
      let arr = [];
      if (array_list.length > 0) {
        for (let i = 0; i < array_list.length; i++) {
          let obj = array_list[i];
          if (obj.teamname == teamname) {
            indexFound = i;
            break;
          }
        }

        if (indexFound !== -1) {
          const newArr = array_list.filter((_, index) => index !== indexFound);
          //console.log("newArr->", newArr);
          let obj = {};
          obj.market_type = betType;
          obj.teamname = teamname;
          obj.bettype = type;
          obj.odds = price;
          obj.amount = amt;
          obj.catmid = roundId;
          arr = [...newArr, obj];
          set_array_list(arr);
        } else {
          let objNew = {};
          objNew.market_type = betType;
          objNew.teamname = teamname;
          objNew.bettype = type;
          objNew.odds = price;
          objNew.amount = amt;
          objNew.catmid = roundId;
          arr = [...array_list, objNew];
          set_array_list(arr);
        }
      } else {
        let obj = {};
        obj.market_type = betType;
        obj.teamname = teamname;
        obj.bettype = type;
        obj.odds = price;
        obj.amount = amt;
        obj.catmid = roundId;
        arr = [...array_list, obj];
        set_array_list(arr);
      }

      console.log("arr->", arr);
    } else {
      alert("Time Up!!");
    }
  };

  useEffect(() => {
    //setGameRoundId()
    if (gameRoundId == "") {
      setGameRoundId(roundId);
    }
    if (gameRoundId !== roundId) {
      setGameRoundId(roundId);
      resetGame();
    }
  }, [roundId]);

  useEffect(() => {
    if (eventStatus == "CLOSED") {
      //resetGame();
    }
  }, [eventStatus]);

  const resetGame = () => {
    setAndarAmount(0);
    setBaharAmount(0);
    setLoopFinalAndarCardArray([]);
    setLoopFinalBaharCardArray([]);
  };

  const clearWinner = () => {
    setAndarWin(false);
    setBaharWin(false);
  };

  const getCardValue = (card) => {
    if (!card || card === "1") return 0;

    let value = card.slice(0, -2);

    if (value === "A") return 1;
    if (value === "J") return 11;
    if (value === "Q") return 12;
    if (value === "K") return 13;

    return Number(value);
  };

  const getSuit = (card) => {
    if (!card || card === "1") return "";

    return card.slice(-2);
  };

  return (
    <GalaxyLayout>
      <div class="container mt-4" id="rbc-app">
        <div>
          <div class="tabs-section">
            <ul class="nav nav-tabs mobile-Tab nav-tabs-glxy">
              <li class="nav-item rbc-games-tab" data-id="0">
                <Link class="nav-link active" to="/galaxy-casino/1">
                  <span class="tab-icon">🎮</span>
                  All Games
                  <span class="badge bg-warning text-dark">6</span>
                </Link>
              </li>
              <li class="nav-item rbc-games-tab" data-id="1">
                <Link class="nav-link " to="/galaxy-casino/2">
                  <span class="tab-icon">🎮</span>
                  Crash
                  <span class="badge bg-warning text-dark">1</span>
                </Link>
              </li>
              <li class="nav-item rbc-games-tab" data-id="3">
                <Link class="nav-link " to="/galaxy-casino/3">
                  <span class="tab-icon">🎮</span>
                  Card
                  <span class="badge bg-warning text-dark">5</span>
                </Link>
              </li>{" "}
            </ul>

            <ul class="nav nav-tabs desktop-tab nav-tabs-glxy">
              <li class="nav-item rbc-games-tab" data-id="0">
                <Link class="nav-link active" to="/galaxy-casino/1">
                  <span class="tab-icon">🎮</span>
                  All Games
                  <span class="badge bg-warning text-dark">6</span>
                </Link>
              </li>
              <li class="nav-item rbc-games-tab" data-id="1">
                <Link class="nav-link " to="/galaxy-casino/2">
                  <span class="tab-icon">🎮</span>
                  Crash
                  <span class="badge bg-warning text-dark">1</span>
                </Link>
              </li>
              <li class="nav-item rbc-games-tab" data-id="3">
                <Link class="nav-link " to="/galaxy-casino/3">
                  <span class="tab-icon">🎮</span>
                  Card
                  <span class="badge bg-warning text-dark">5</span>
                </Link>
              </li>{" "}
            </ul>
          </div>

          <div id="rbc-game-view">
            <div class="container-fluid RBC-Jetx-MainContainer">
              <div class="RBC-Jetx-LeftPanel">
                {Object.keys(resultList).map((key) => (
                  <div
                    className="resultbox"
                    style={{
                      backgroundColor:
                        resultList[key] === 1
                          ? "rgb(71 85 105 / var(--tw-bg-opacity, 1))"
                          : "rgb(100 116 139 / var(--tw-bg-opacity, 1))"
                    }}
                  >
                    {resultList[key] === 1 ? "A" : "B"}
                  </div>
                ))}
              </div>
              <div class="RBC-Jetx-CenterPanel">
                <div class="RBC-Jetx-GameScreen B-ANBH-height scroll-containeraviator-galaxy">
                  <div class="andbhrmain" style={{ paddingTop: "50px" }}>
                    <div class="RBC-2-chip-odds-view-ctn-glaxy desktop-tab">
                      <div class="RBC-2-chip-odds-view-layer">
                        <div class="t-l-ctn col-3">
                          <div class="total-bets">
                            <span
                              class="text"
                              style={{ color: "#b97f2b", fontSize: "12px" }}
                            >
                              Total Bet
                            </span>{" "}
                            <span
                              class="t-count total-bets2"
                              style={{ color: "#cf8d2e", fontSize: "12px" }}
                            >
                              0
                            </span>
                          </div>
                        </div>
                        <div class="chipDeck-glaxy col-6">
                          <div class="chip-ctn">
                            <div id="fadeIn" class="show-stakes">
                              <div class="chips-layer">
                                <div
                                  onClick={() => setChipActive(100)}
                                  className={
                                    chipActive === 100
                                      ? "cdChip active"
                                      : "cdChip noActive"
                                  }
                                >
                                  <img
                                    src="../assets/galaxy/img/chip1.svg"
                                    alt=""
                                    class="chipimg"
                                  />{" "}
                                  <span class="cdChipSpan" dataval="100">
                                    100
                                  </span>
                                </div>
                                <div
                                  onClick={() => setChipActive(500)}
                                  className={
                                    chipActive === 500
                                      ? "cdChip active"
                                      : "cdChip noActive"
                                  }
                                >
                                  <img
                                    src="../assets/galaxy/img/chip2.svg"
                                    alt=""
                                    class="chipimg"
                                  />{" "}
                                  <span class="cdChipSpan" dataval="500">
                                    500
                                  </span>
                                </div>
                                <div
                                  onClick={() => setChipActive(1000)}
                                  className={
                                    chipActive === 1000
                                      ? "cdChip active"
                                      : "cdChip noActive"
                                  }
                                >
                                  <img
                                    src="../assets/galaxy/img/chip3.svg"
                                    alt=""
                                    class="chipimg"
                                  />{" "}
                                  <span class="cdChipSpan" dataval="1000">
                                    1k
                                  </span>
                                </div>
                                <div
                                  onClick={() => setChipActive(2000)}
                                  className={
                                    chipActive === 2000
                                      ? "cdChip active"
                                      : "cdChip noActive"
                                  }
                                >
                                  <img
                                    src="../assets/galaxy/img/chip4.svg"
                                    alt=""
                                    class="chipimg"
                                  />{" "}
                                  <span class="cdChipSpan" dataval="2000">
                                    2k
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="ure-btn col-3">
                          <div class="undo-ctn undoFunc" onClick={() => undo()}>
                            <img
                              src="../assets/galaxy/img/undo-icon.svg"
                              alt=""
                              class="undo-icon"
                            />
                            <span>Undo</span>
                          </div>
                          <div
                            class="reset-ctn resetFunc"
                            onClick={() => resetGame()}
                          >
                            <img
                              src="../assets/galaxy/img/reset-icon.svg"
                              alt=""
                              class="reset-icon"
                            />
                            <span>Reset</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="RBC-2-chip-odds-view-ctn-glaxy mobile-View">
                      <div class="RBC-2-chip-odds-view-layer">
                        <div class="t-l-ctn col-12">
                          <div class="total-bets">
                            <span
                              class="text"
                              style={{ color: "#b97f2b", fontSize: "12px" }}
                            >
                              Total Bet
                            </span>{" "}
                            <span
                              class="t-count total-bets2"
                              style={{ color: "#b97f2b", fontSize: "12px" }}
                            >
                              0
                            </span>
                          </div>
                          <div
                            class="undo-ctn undoFunc"
                            style={{ marginLeft: "40px" }}
                            onClick={() => undo()}
                          >
                            <img
                              src="../assets/galaxy/img/undo-icon.svg"
                              alt=""
                              class="undo-icon"
                            />
                            <span>Undo</span>
                          </div>
                          <div
                            class="reset-ctn resetFunc"
                            onClick={() => resetGame()}
                          >
                            <img
                              src="../assets/galaxy/img/reset-icon.svg"
                              alt=""
                              class="reset-icon"
                            />
                            <span>Reset</span>
                          </div>
                        </div>
                      </div>
                      <div class="chipDeck-glaxy col-12">
                        <div class="chip-ctn">
                          <div id="fadeIn" class="show-stakes">
                            <div class="chips-layer">
                              <div
                                onClick={() => setChipActive(100)}
                                className={
                                  chipActive === 100
                                    ? "cdChip active"
                                    : "cdChip noActive"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt=""
                                  class="chipimg"
                                />{" "}
                                <span class="cdChipSpan">100</span>
                              </div>

                              <div
                                onClick={() => setChipActive(500)}
                                className={
                                  chipActive === 500
                                    ? "cdChip active"
                                    : "cdChip noActive"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip2.svg"
                                  alt=""
                                  class="chipimg"
                                />{" "}
                                <span class="cdChipSpan" dataval="500">
                                  500
                                </span>
                              </div>

                              <div
                                onClick={() => setChipActive(1000)}
                                className={
                                  chipActive === 1000
                                    ? "cdChip active"
                                    : "cdChip noActive"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip3.svg"
                                  alt=""
                                  class="chipimg"
                                />{" "}
                                <span class="cdChipSpan" dataval="1000">
                                  1K
                                </span>
                              </div>
                              <div
                                onClick={() => setChipActive(2000)}
                                className={
                                  chipActive === 2000
                                    ? "cdChip active"
                                    : "cdChip noActive"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip4.svg"
                                  alt=""
                                  class="chipimg"
                                />{" "}
                                <span class="cdChipSpan" dataval="2000">
                                  2k
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class={
                        left_time <= 3
                          ? "overlayRoulettelock-galaxy"
                          : "overlayRoulettelock-galaxy hides"
                      }
                      style={{ height: "43%" }}
                    >
                      <div style={{ textAlign: "center" }}>
                        <svg
                          focusable="false"
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          data-testid="LockIcon"
                          class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium lock-icon css-vubbuv"
                          style={{ width: "70px", filter: "invert(0)" }}
                        >
                          <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"></path>
                        </svg>{" "}
                      </div>
                    </div>
                    <div class="RBC-AB-container" style={{ marginTop: "20px" }}>
                      <div
                        class="RBC-Basic-Div RBC-AB-top span1details"
                        id="runner1b1span"
                        data-teamname="Bahar"
                        data-bettype="b"
                        onClick={() =>
                          initializeBet("m", "Bahar", "b", baharOdd)
                        }
                      >
                        <span class="odd hides">{baharOdd}</span>
                        <div class="RBC-AB-watermark">BAHAR</div>
                        <div class="RBC-AB-cards" id="game-cards1">
                          {loopFinalAndarCardArray.map((item) => (
                            <img
                              src={`../assets/galaxy/img/cards3/${item}.svg`}
                              class="RSMImageView animate__animated"
                            />
                          ))}
                        </div>
                      </div>
                      <div
                        class="RBC-Basic-Div RBC-AB-bottom span1details"
                        id="runner2b1span"
                        data-teamname="Andar"
                        data-bettype="b"
                        onClick={() =>
                          initializeBet("m", "Andar", "b", andarOdd)
                        }
                      >
                        <span class="odd hides">{andarOdd}</span>
                        <div class="RBC-AB-watermark">ANDAR</div>

                        <div class="RBC-AB-cards" id="game-cards2">
                          {loopFinalBaharCardArray.map((item) => (
                            <img
                              src={`../assets/galaxy/img/cards3/${item}.svg`}
                              class="RSMImageView animate__animated"
                            />
                          ))}
                        </div>
                      </div>
                      <div class="RBC-AB-center">
                        <div
                          class={
                            baharAmount > 0
                              ? "Rou-image-container-glaxy"
                              : "Rou-image-container-glaxy hide"
                          }
                          style={{ top: "0%", marginTop: "-10px" }}
                          id="b1Chips"
                        >
                          <img
                            src="../assets/galaxy/img/chip1.svg"
                            alt="Winner Icon"
                            class="rol-winner-icon-glaxy"
                          />
                          <span
                            class="Rou-image-text-glaxy"
                            style={{ color: "black" }}
                          >
                            {" "}
                            {baharAmount}
                          </span>
                        </div>
                        <span
                          className={
                            baharWin
                              ? "zero-value-glaxy"
                              : "zero-value-glaxy hides"
                          }
                          style={{
                            top: "0%",
                            marginTop: "-10px",
                            zIndex: "99999999"
                          }}
                        >
                          <img
                            src="../assets/galaxy/img/roul-winner.webp"
                            alt="Zero Icon"
                            class="zero-icon"
                          />
                        </span>
                        <img
                          id="game-cards3"
                          src={`../assets/galaxy/img/cards3/${jokerCard}.svg`}
                          alt="Center Card"
                          class="CommImg"
                        />

                        <div
                          class={
                            andarAmount > 0
                              ? "Rou-image-container-glaxy"
                              : "Rou-image-container-glaxy hide"
                          }
                          style={{ top: "100%", marginTop: "10px" }}
                          id="b2Chips"
                        >
                          <img
                            src="../assets/galaxy/img/chip1.svg"
                            alt="Winner Icon"
                            class="rol-winner-icon-glaxy"
                          />
                          <span
                            class="Rou-image-text-glaxy"
                            style={{ color: "black" }}
                          >
                            {andarAmount}
                          </span>
                        </div>

                        <span
                          className={
                            andarWin
                              ? "zero-value-glaxy"
                              : "zero-value-glaxy hides"
                          }
                          style={{
                            top: "100%",
                            marginTop: "10px",
                            zIndex: "99999999"
                          }}
                        >
                          <img
                            src="../assets/galaxy/img/roul-winner.webp"
                            alt="Zero Icon"
                            class="zero-icon"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="waveStrength-3" style={{ marginBottom: "-1px" }}>
                    <div class="wv4 wave">
                      <div class="wv3 wave">
                        <div class="wv2 wave">
                          <div class="wv1 wave"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="round-id-container">
                    AB &nbsp;<span>{roundId}</span>
                    <span class="info-icon openPopUpDetail">ⓘ</span>
                  </div>

                  <div class="base-timer">
                    <svg
                      class="progressBar"
                      x="0px"
                      y="0px"
                      viewBox="0 0 80 80"
                      style={{ background: "transparent" }}
                    >
                      <path
                        class="track"
                        d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                      ></path>
                      <path
                        class="fill"
                        d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                        style={{ strokeDashoffset: "0" }}
                      ></path>
                      <text class="value" x="50%" y="55%">
                        {left_time}
                      </text>
                    </svg>
                  </div>
                  <div class="Connectedclients-glxy mt-1">
                    <span class="user-icon"></span>{" "}
                    <b>
                      <span id="UsersCount" class="number">
                        57
                      </span>
                    </b>
                  </div>
                </div>
              </div>
              <div class="RBC-Jetx-RightPanel">
                <table class="RBC-Jetx-Table">
                  <thead>
                    <tr>
                      <th>Runner</th>
                      <th>Price</th>
                      <th>Size</th>
                    </tr>
                  </thead>
                  <tbody id="refreshhistory"></tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>
        {`
          .zero-icon{
            width: 36px;
            height: 36px;
          }
             `}
      </style>
    </GalaxyLayout>
  );
}
